export default "__VITE_ASSET__nE5OUwlq__"